/** When each policy's wording last changed (ISO dates); bump with every wording change. */
export const LEGAL_LAST_UPDATED = {
  PRIVACY_POLICY: '2026-10-19',
  TERMS_OF_USE: '2026-10-04',
} as const;
